import React, { PureComponent } from 'react';
import { Row, Col, Glyphicon, Button } from 'react-bootstrap';
import {PageView, Event} from '../../../components/baseComponents/Tracking';
import searchIcon from '../../../../assets/images/icons/glass.svg';

class LinksSearchBar extends PureComponent {
  state = {
    keyword: '',
  }

  componentDidMount() {
    PageView();
  }

  handleInputChange = (e) => {    
    this.setState({keyword: e.target.value});
  }
  
  handleOnKeyUp = () => {
    if (this.state.keyword.length > 2) {
      this.props.onSearch(this.state.keyword);
      var duration = 1000;
      clearTimeout(this.inputTimer);

      this.inputTimer = setTimeout(() => {
        this.props.showLinksResults();
        Event("Search", "Keyword", this.state.keyword)
      }, duration);
    } else {
      this.props.hideLinksResults();
    }
  }

  searchKeyword = () => {
    this.props.onSearch(this.state.keyword);
  };

  render () {
    const {
      keyword,
    } = this.state;

    return (
      <Row className="search-bar-row front-search-row">
        <Col sm={12}>
          <div className="input-group btn-container">
            <span className="input-group-btn mobile">
              <Button 
                onClick={this.searchKeyword.bind()}
                type="button"
              >
                <Glyphicon glyph="search" />
              </Button>
            </span>
            <input
              type="text"
              name="keyword"
              value={keyword}
              onChange={this.handleInputChange}
              onKeyUp={this.handleOnKeyUp}
              placeholder="Find anything you need…"
              className="form-control search-input-landing"
            />
            <span className="input-group-btn desktop">
              <img
                src={searchIcon}
                alt=""
                className="glass-dsk"
              />
            </span>
          </div>
        </Col>
      </Row>
    );
  }
}

export default LinksSearchBar;


// WEBPACK FOOTER //
// ./src/app/screens/landing/links/linksSearchBar.js